import { app } from '../../../app';
import { Controller } from './login-web-saml.controller';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.old-login-with-app-id', {
        url: '/oldLogin/:applicationId?appName&appType&icon&SAMLTracker',
        templateUrl: require('../old-login.html'),
        controller: Controller,
    });

    $stateProvider.state('public.login-web-saml', {
        url: '/loginWebSAML/:applicationId?appName&appType&icon&SAMLTracker',
        params :{
        	loginWithPassword : false,
        },
        templateUrl: require('./login-web-saml.html'),
        controller: Controller,
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/login-web-saml/login-web-saml.state.js